module.exports = __webpack_public_path__ + "img/y6.1d0da7ac.webp";